import { MinusCircleFilled } from '@ant-design/icons';
import { Input } from 'antd';
import type { FC } from 'react';
import { useContext, useEffect, useRef } from 'react';
import { readonlyContext } from '../../../context';
import type { InputPropsWithOnRemove } from './type';

export const InputWithRemoveAction: FC<InputPropsWithOnRemove> = (props) => {
  // props
  const { onRemove, autoScrollIntoView = false, ...inputProps } = props;
  // refs
  const sectionRef = useRef<HTMLElement>(null);
  // context
  const readonly = useContext(readonlyContext);
  // effect
  useEffect(() => {
    if (autoScrollIntoView) {
      sectionRef.current?.scrollIntoView({
        behavior: 'smooth',
        inline: 'nearest',
      });
    }
  }, [autoScrollIntoView]);

  if (readonly) {
    return <Input {...inputProps} />;
  }

  return (
    <section className="flex gap-2 items-center" ref={sectionRef}>
      <Input {...inputProps} />
      <button
        type="button"
        title="删除"
        className="hidden w-6 h-6 rounded-half text-base text-secondary-1 hover:text-error active:bg-active group-hover:block"
        onClick={onRemove}
      >
        <MinusCircleFilled />
      </button>
    </section>
  );
};
